import { useEffect, useMemo } from 'react'

import { getTokenCatalog } from '@sirius-cybernetics-42/product-config'

import { getActiveChainId } from '@/config/active'
import { syncTokenPolicyFromCatalog } from '@/config/marketPolicy'
import type { TokenCatalogEntry } from '@/data/marketApi/types'

/**
 * Catálogo product-config (seed + políticas).
 * Sincroniza `marketPolicy` vía `syncTokenPolicyFromCatalog`.
 *
 * Para known-check / pickers / import usa `useOperativeTokenCatalog`
 * (merge Nutrimatic-first + este seed). No mezclar policy aquí.
 */
export function useTokenCatalog() {
  const chainId = getActiveChainId()

  const entries = useMemo(() => getTokenCatalog(chainId), [chainId])

  useEffect(() => {
    syncTokenPolicyFromCatalog(chainId, entries)
  }, [chainId, entries])

  return {
    entries,
    isLoading: false,
    isFromApi: false,
  }
}

export function useTokenCatalogEntries(): TokenCatalogEntry[] {
  return useTokenCatalog().entries
}
